import Image from 'next/image'

export const ProfileBanner = ({
	bannerUrl,
	logoUrl,
}: {
	bannerUrl?: string | null
	logoUrl?: string | null
}) => (
	<div
		className='from-primary/20 relative w-full bg-linear-to-tl to-[#ff5c28]/20 bg-cover max-md:h-28'
		style={
			bannerUrl
				? {
						backgroundPosition: 'center',
						backgroundSize: 'cover',
						backgroundImage: `url(${bannerUrl})`,
					}
				: undefined
		}
	>
		{bannerUrl ? (
			<Image
				src={bannerUrl}
				alt=''
				width={1400}
				height={220}
				unoptimized
				className='hidden h-auto w-full md:block'
			/>
		) : (
			<div className='aspect-[70/11] w-full' />
		)}

		{logoUrl && (
			<div className='absolute top-1/2 right-6 flex -translate-y-1/2 items-center justify-center rounded-xl p-2 md:right-8 md:p-3'>
				<Image
					src={logoUrl}
					width={100}
					height={100}
					unoptimized
					className='size-[70px] object-contain md:size-[100px]'
					alt=''
				/>
			</div>
		)}
	</div>
)
